export default "__VITE_ASSET__9qkKrGsH__"